const HIDDEN_ACCREDITATION_NAMES = [
  'IEEE-CS', 'IEEE CS', 'IEEE', 'ACM',
  'MÜDEK', 'MUDEK', 'ABET', 'TEPDAD', 'SABAK', 'HEPDAK', 'EPDAD', 'FEDEK',
  'İLAD', 'ILEDAK', 'İLEDAK', 'TURAK', 'TAPLAK', 'MİAK', 'MIAK', 'ECZAKDER',
  'DEPAD', 'UTEAK', 'VEDEK', 'ZİDEK', 'ZIDEK', 'AACSB', 'EQUIS', 'AMBA', 'WFME',
];

const accreditationNamePattern = new RegExp(
  `(?:${HIDDEN_ACCREDITATION_NAMES.join('|')})(?:\\s*(?:/|,|ve)\\s*(?:${HIDDEN_ACCREDITATION_NAMES.join('|')}))*(?:\\s+(?:önerileri|ölçütleri|kriterleri|standartları|akreditasyonu|müfredat rehberleri))?`,
  'giu',
);

export function sanitizePublicText(value) {
  if (typeof value !== 'string') return value;
  return value
    .replace(accreditationNamePattern, 'alana özgü kalite ölçütleri')
    .replace(/(?:alana özgü kalite ölçütleri)(?:\s*[/,]|\s+ve)\s*(?:alana özgü kalite ölçütleri)/giu, 'alana özgü kalite ölçütleri');
}

export function sanitizePublicData(value) {
  if (typeof value === 'string') return sanitizePublicText(value);
  if (Array.isArray(value)) return value.map(sanitizePublicData);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, sanitizePublicData(item)]),
    );
  }
  return value;
}
